import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Phone, Mail } from "lucide-react";
import { Facebook } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import homeCarousel1 from "../../../src/assets/Carousal/homeCarousel1.png";
import homeCarousel2 from "../../../src/assets/Carousal/homeCarousel2.png";
import homeCarousel3 from "../../../src/assets/Carousal/homeCarousel3.png";
import homeCarousel4 from "../../../src/assets/Carousal/homeCarousel4.png";
import homeCarousel5 from "../../../src/assets/Carousal/homeCarousel5.png";
import Button from "../Button";

function HomeCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(1); // ← NEW
  const intervalRef = useRef(null);
  const navigate = useNavigate();

  const data = [
    {
      id: 1,
      img: homeCarousel3,
      content: (
        <div className="space-y-2 text-left w-full px-4 mt-4 text-sm sm:text-base lg:text-lg">
          <h2 className="text-[#274760] text-xl sm:text-4xl lg:text-6xl font-bold">MEMBERSHIP BENEFITS</h2>
          <p className="font-semibold text-[#274760] text-lg">Special Benefit:</p>
          <ul className="text-[#274760] list-disc">
            <li>Free Health Assessments for Family Members</li>
          </ul>
          <p className="font-semibold text-[#274760] text-lg">Basic Benefits:</p>
          <ul className="list-disc text-[#274760] pl-4">
            <li>Members can get special discount in workshop and Diploma Course.</li>
            <li>Members can get preferences for participating in part time community service projects with good remuneration.</li>
            <li>Member will get FREE online study materials for BRT preparation.</li>
            <li>FREE Health Magazine</li>
          </ul>
          <button
            onClick={() => navigate("/signup")}
            className="bg-white text-[#3BB3F5] font-semibold px-8 py-3 rounded-full text-lg shadow-md hover:scale-105 transition-transform mt-4"
          >
            GET MEMBERSHIP BENEFITS
          </button>
        </div>
      ),
    },
    {
      id: 2,
      img: homeCarousel2,
      content: (
        <div className="space-y-3 text-left w-full px-4 mt-4 text-sm sm:text-base lg:text-lg">
          <h2 className="text-[#274760] text-xl sm:text-4xl lg:text-6xl font-bold">HEALTH CHECKUP PLANS</h2>
          <p className="text-[#274760] text-md md:text-lg font-semibold">
            Take advantage of comprehensive health plans thoughtfully designed to support your well-being.
          </p>
          <ul className="list-disc text-[#274760] pl-4 pt-2">
            <li>Experienced Healthcare Professionals</li>
            <li>Comprehensive Services</li>
            <li>Beneficiary-centered Approach</li>
            <li>State-of-the-art Facilities</li>
          </ul>
          <button
            onClick={() => navigate("/signup")}
            className="bg-white text-[#3BB3F5] font-semibold px-8 py-3 rounded-full text-lg shadow-md hover:scale-105 transition-transform mt-4"
          >
            Get Health Checkup Plans
          </button>
        </div>
      ),
    },
    {
      id: 3,
      img: homeCarousel1,
      content: (
        <div className="space-y-3 text-left w-full px-4 mt-4 text-sm sm:text-base lg:text-lg">
          <h2 className="text-[#274760] text-xl sm:text-4xl lg:text-6xl font-bold">FREE Health Counselling & Awareness Session</h2>
          <p className="text-[#274760] text-md md:text-lg font-semibold">
            What's Included in Your FREE Health Counselling & Awareness Session
          </p>
          <ul className="list-disc text-[#274760] pl-4">
            <li>Overview of common health issues and vital signs assessment.</li>
            <li>Preventive health tips tailored to group needs.</li>
            <li>Health risk awareness and early detection insights.</li>
            <li>Interactive Q&A with personalized consultation.</li>
            <li>Educational materials and resources for learning.</li>
          </ul>
          <button
            onClick={() => navigate("/signup")}
            className="bg-white text-[#3BB3F5] font-semibold px-8 py-3 rounded-full text-lg shadow-md hover:scale-105 transition-transform mt-4"
          >
            Book your free slot
          </button>
        </div>
      ),
    },
    {
      id: 4,
      img: homeCarousel4,
      content: (
        <div className="space-y-3 text-left w-full px-4 mt-4 text-sm sm:text-base lg:text-lg">
          <h2 className="text-[#274760] text-xl sm:text-4xl lg:text-6xl font-bold">SPEAK WITH YOUR DOCTOR</h2>
          <p className="text-[#274760] text-md md:text-lg font-semibold">
            Seamless, stress-free consultation with a doctor—right from the comfort of your home.
          </p>
          <ul className="list-disc text-[#274760] pl-4">
            <li>Consult from home, no travel or waiting.</li>
            <li>Quick access to doctors anytime.</li>
            <li>Safe for elderly/immunocompromised patients.</li>
            <li>Save on travel and waiting room costs.</li>
            <li>Get prescriptions and follow-ups digitally.</li>
          </ul>
          <button
            onClick={() => navigate("/signup")}
            className="bg-white text-[#3BB3F5] font-semibold px-8 py-3 rounded-full text-lg shadow-md hover:scale-105 transition-transform mt-4"
          >
            Call Doctor
          </button>
        </div>
      ),
    },
    {
      id: 5,
      img: homeCarousel5,
      content: (
        <div className="space-y-3 text-left w-full px-4 mt-4 text-sm sm:text-base lg:text-lg">
          <h2 className="text-[#274760] text-xl sm:text-4xl lg:text-6xl font-bold">CALL US</h2>
          <p className="text-[#274760] text-md md:text-lg font-semibold">Need Assistance? We're Here to Help!</p>
          <ul className="list-disc text-[#274760] pl-4">
            <li>If you require any support or have questions, simply call us at our helpline numbers.</li>
            <li>Our dedicated team will promptly get in touch with you and provide the assistance you need.</li>
          </ul>
          <br className="block md:hidden" />
          <h3 className="text-[#274760] text-lg md:text-xl font-semibold mt-6">HOW TO REACH US</h3>
          <div className="flex gap-10 text-[#274760] mt-4 text-lg w-full ">
            <a href="tel:+91 3614516663" target="_blank" rel="noopener noreferrer">
              <Phone className="transition-transform duration-300 ease-in-out hover:text-blue-400 cursor-pointer hover:scale-110" />
            </a>
            <a href="mailto:nhwm.oh@gmail.com" target="_blank" rel="noopener noreferrer">
              <Mail className="transition-transform duration-300 ease-in-out hover:text-red-500 cursor-pointer hover:scale-110" />
            </a>
            <a href="https://www.facebook.com/NHWMOH/" target="_blank" rel="noopener noreferrer">
              <Facebook className="transition-transform duration-300 ease-in-out hover:text-blue-500 cursor-pointer hover:scale-110 mt-[-5px]" />
            </a>
          </div>
        </div>
      ),
    },
  ];

  const startAutoSlide = () => {
    stopAutoSlide();
    intervalRef.current = setInterval(() => {
      setDirection(1); // Forward during auto-slide
      setCurrentIndex((prev) => (prev + 1) % data.length);
    }, 4000);
  };

  const stopAutoSlide = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  useEffect(() => {
    startAutoSlide();
    return stopAutoSlide;
  }, []);

  const gotoPrev = () => {
    setDirection(-1); // ← BACKWARD
    setCurrentIndex((prev) => (prev === 0 ? data.length - 1 : prev - 1));
  };

  const gotoNext = () => {
    setDirection(1); // ← FORWARD
    setCurrentIndex((prev) => (prev + 1) % data.length);
  };

  return (
    <div className="px-4 sm:px-8 mx-auto container">
      <div
        className="relative w-full h-fit my-5 overflow-hidden rounded-xl shadow-lg bg-blue-200"
        onMouseEnter={stopAutoSlide}
        onMouseLeave={startAutoSlide}
      >
        {/* Animation Updated → */}
        <AnimatePresence mode="popLayout">
          <motion.div
            key={data[currentIndex].id}
            initial={{ x: direction === 1 ? "100%" : "-100%", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: direction === 1 ? "-100%" : "100%", opacity: 0 }}
            transition={{ duration: 0.7, ease: "easeInOut" }}
            className="flex flex-col lg:flex-row items-start md:justify-between p-2 sm:p-4"
          >
            <div className="w-full lg:w-auto">
              <motion.img
                key={data[currentIndex].img}
                src={data[currentIndex].img}
                alt=""
                initial={{ scale: 0.95, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.6 }}
                className="w-full h-28 sm:h-40 lg:h-[500px] object-cover lg:object-contain rounded-md ml-[0] lg:ml-[50px]"
              />
            </div>

            <motion.div
              key={data[currentIndex].id + "-content"}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="w-full lg:w-3/5 mt-2 lg:mt-0"
            >
              <div className="text-black drop-shadow ml-[0] md:ml-[50px]">
                {data[currentIndex].content}
              </div>
            </motion.div>
          </motion.div>
        </AnimatePresence>

        {/* Navigation Buttons */}
        <button
          onClick={gotoPrev}
          className="absolute left-[-20px] sm:left-4 top-1/2 -translate-y-5 text-white md:text-black p-2 sm:p-3 bg-none md:bg-white rounded-full transition-transform hover:scale-110 active:scale-90 z-20"
        >
          <ChevronLeft className="w-12 h-12 sm:w-10 sm:h-10 md:text-black" />
        </button>

        <button
          onClick={gotoNext}
          className="absolute right-[-20px] sm:right-4 top-1/2 -translate-y-5 text-white md:text-black p-2 sm:p-3 bg-none md:bg-white rounded-full transition-transform hover:scale-110 active:scale-90 z-20"
        >
          <ChevronRight className="w-12 h-12 sm:w-10 sm:h-10 md:text-black" />
        </button>
      </div>
    </div>
  );
}

export default HomeCarousel;
